import { Injectable, OnDestroy } from '@angular/core';
import { EventService } from './event.service';
import { SessionContext } from '../shared/model/session-context.model';
// import { HWCService } from './hwc.service';
import { Observable, of, Subscription } from 'rxjs';
import { DefaultDataService, enumAS365FeatureFlags } from './default-data.service';
import { map, take } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { Employee } from '../shared/model/employee.model';
import { APIResult, EmployeeService } from './employee.service';
import { AutoLogoutService } from './auto-logout.service';
import { Branch } from '../shared/model/Branch.model';
import { Resource } from '../shared/model/resource.model';
import { enumReasonCategory } from '../shared/model/ReasonCode';
import { Terminal } from '../shared/model/Terminal.model';
import { watch } from 'rxjs-watcher';
import { NavigationService } from './navigation.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SessionContextService implements OnDestroy {

  onDefaultDataChanged$: Subscription;
  onHWCFound$: Subscription;
  onHWCConnected$: Subscription;
  onHWCDisconnected$: Subscription;

  constructor(public defaultData: DefaultDataService,
    private auth: AuthorizeService,
    private events: EventService,
    private autoLogout: AutoLogoutService,
    private employeeAuth: EmployeeService,
    private nav: NavigationService,
    private router: Router,
    public ctx: SessionContext) {
    console.log('Starting Session Context Service');

    // Load Selected employee from SessionStorage if we are authenticated
    this.auth.isAuthenticated().pipe(take(1)).subscribe((r) => {
      if (r) {
        const employeeId = sessionStorage.getItem('EmployeeId');
        if (employeeId) {
          this.ctx.EmployeeId = parseInt(employeeId, 10);
        }
        const e = sessionStorage.getItem('Employee');
        if (e) {
          this.ctx.Employee = Employee.CreateFrom(JSON.parse(e));
          this.ctx.EmployeeId = this.ctx.Employee.EmployeeId;

          // This will also update the Navigation Service where the menus are processed.
          this.auth.privString = this.ctx.Employee.PrivString;
          this.nav.SetEmployeePrivs(this.ctx.Employee.PrivString);
        }
      }
    });

    // Load branch from Local Storage
    this.LoadBranch();

    const tid = localStorage.getItem('TerminalId');
    if (tid) {
      this.ctx.TerminalId = parseInt(tid, 10);
      this.selectTerminal(this.ctx.TerminalId);
    }

    this.onDefaultDataChanged$ = this.events.onDefaultDataChanged
      // .pipe(watch("Session - onDefaultDataChanged"))
      .subscribe(d => {
        if (d) {
          this.ctx.CustomerName = d.CustomerName;
          if (this.ctx.BranchId < 0)
            this.LoadBranch();
          else
            this.selectBranch(this.ctx.BranchId);

          if (this.ctx.TerminalId > 0)
            this.selectTerminal(this.ctx.TerminalId);
        }
      });

    this.onHWCFound$ = this.events.onHWCFound
      // .pipe(watch("Session - onHWCFound"))
      .subscribe(hwcInfo => {
        if (hwcInfo) {
          // HWC Found, save a copy of the Till Drawer List to session
          this.ctx.TerminalIP = hwcInfo.IPAddress;
          this.ctx.HWCInfo = hwcInfo;
        }
      });

    // Update Session Context depending on if HWC is found or not
    this.onHWCConnected$ = this.events.onHWCConnected
      // .pipe(watch("Session - onHWCConnected"))
      .subscribe(hwcDongleInfo => {
        if (hwcDongleInfo) {
          if (this.ctx.HasHWCConnected === false) {
            this.ctx.HasHWCConnected = true;
            this.events.SessionContextChanged(this.ctx);
          }
        } else {
          if (this.ctx.HasHWCConnected === true) {
            this.ctx.HasHWCConnected = false;
            this.events.SessionContextChanged(this.ctx);
          }
        }

        if (hwcDongleInfo) {
          if (hwcDongleInfo.BranchUId) {
            const branch = this.defaultData.defData.GetBranchFromUId(hwcDongleInfo.BranchUId);
            if (branch) {
              this.defaultData.defData.Branches.forEach(i => i.HWCDongleInfo = null);
              this.ctx.HasHWC = true;
              this.ctx.TerminalIP = hwcDongleInfo.IPAddress;
              branch.HWCDongleInfo = hwcDongleInfo;
              this.selectBranch(branch.BranchId);
            }
          }
        } else {
          this.ctx.HasHWC = false;
        }
        this.events.SessionContextChanged(this.ctx);
      });

    this.onHWCDisconnected$ = this.events.onHWCDisconnected
      // .pipe(watch("Session - onHWCDisconnected"))
      .subscribe((r) => {
        if (this.ctx.HasHWCConnected === true) {
          this.ctx.HasHWCConnected = false;
          this.events.SessionContextChanged(this.ctx);
        }
      });
  }

  ngOnDestroy() {
    if (this.onDefaultDataChanged$) { this.onDefaultDataChanged$.unsubscribe(); }
    if (this.onHWCFound$) { this.onHWCFound$.unsubscribe(); }
    if (this.onHWCConnected$) { this.onHWCConnected$.unsubscribe(); }
    if (this.onHWCDisconnected$) { this.onHWCDisconnected$.unsubscribe(); }
  }

  LoadBranch() {
    const branchIdString = localStorage.getItem('BranchId');
    var branchId: number = -1;
    if (branchIdString)
      branchId = parseInt(branchIdString, 10);
    else
      branchId = -1;

    if (branchId < 0 && this.defaultData.defData.Branches.length > 0)
      branchId = this.defaultData.defData.Branches[0].BranchId;

    var storedBranch = this.defaultData.defData.GetBranchFromId(branchId);

    if (this.defaultData.defData.AuthEmployeeId > 0) {
      const authEmployee = this.defaultData.defData.Employees.find(i => i.EmployeeId === this.defaultData.defData.AuthEmployeeId);
      if (authEmployee.BranchId > 0) {
        var employeeBranch = this.defaultData.defData.GetBranchFromId(authEmployee.BranchId);
        if (employeeBranch) {
          branchId = authEmployee.BranchId;
          storedBranch = employeeBranch;
        }
      }
    }

    if (storedBranch) {
      localStorage.setItem('BranchId', storedBranch.BranchId.toString());
      this.selectBranch(storedBranch.BranchId);
      // this.events.BranchChanged(storedBranch);
    }
    else {
      localStorage.removeItem('BranchId');
    }
  }

  public IsFeatureEnabled(featureName: enumAS365FeatureFlags ): boolean {    
    return this.defaultData.IsFeatureEnabled(featureName);
  }

  public GetSelectedBranch(): Branch {
    return this.GetBranchFromId(this.ctx.BranchId);
  }

  public GetBranchFromId(BranchId: number): Branch {
    return this.defaultData.defData.GetBranchFromId(BranchId);
  }

  public selectBranch(branchId: number) {
    console.log("SelectBranch " + branchId);

    if (this.ctx.BranchId == branchId)
      return;

    const b = this.defaultData.defData.GetBranchFromId(branchId);
    if (b) {
      // Only change branch if different from currently selected branch
      this.nav.SetBranch(b);

      if (this.ctx.BranchId !== branchId) {
        this.ctx.BranchId = branchId;
        this.ctx.BranchUId = b.UID;
        localStorage.setItem('BranchId', String(branchId));

        // Tell app branch has changed.
        this.events.BranchChanged(b);

        // // Make sure that if branch changes we do not remain on VoidSale or General sale pages
        // if (window.location.href.endsWith("/frontoffice/voidSale") || window.location.href.endsWith("/frontoffice/pos")) {
        //   this.router.navigate(["/frontoffice/aptbook"]);
        // }
      }
    }
  }

  public GetSelectedTerminal(): Terminal {
    var t = this.GetTerminalFromId(this.ctx.TerminalId);
    if (t.TillConnected && t.TillDrawerName && this.ctx.HWCInfo && this.ctx.HWCInfo.TillDrawers) {
      var x = this.ctx.HWCInfo.TillDrawers.find(i => i.FriendlyName == t.TillDrawerName);
      if (x)
        t.TillDrawerId = x.TillId;
    }
    return t;
  }

  public GetTerminalFromId(TerminalId: number): Terminal {
    return this.defaultData.defData.Terminals.find(i => i.Id == TerminalId);
  }

  public GetTerminal(tIP: string, branchId: number): Terminal {
    return this.defaultData.defData.Terminals.find(i => i.IPAddress === tIP && i.Branch === branchId);
  }

  public selectTerminal(terminalId: number): Terminal {
    const t = this.defaultData.Terminals.find(o => o.Id === terminalId);
    if (t) {

      this.nav.SetTerminal(t);

      // Till Drawer by name in HWC config.
      // If we find till drawer by name, save the till drawer Id in the terminal record.
      if (this.ctx.HasHWC && this.ctx.HasHWCConnected) {
        var x = this.ctx.HWCInfo.TillDrawers.find(i => i.FriendlyName == t.TillDrawerName);
        if (x) {
          t.TillDrawerId = x.TillId;
        }
      }

      this.ctx.TerminalId = terminalId;
      this.ctx.TerminalName = t.Name;
      this.ctx.TerminalIP = t.IPAddress;

      localStorage.setItem('TerminalId', String(terminalId));

      // Tell app terminal has changed.
      this.events.TerminalChanged(t);
      this.events.SessionContextChanged(this.ctx);
      return t;
    }
  }

  public selectEmployee(employeeId: number, pin: string): Observable<APIResult> {
    const x = this.defaultData.Employees.find(o => o.EmployeeId === employeeId);
    if (x) {
      return this.employeeAuth.ValidateEmployeePin(x.UID, pin).pipe(
        take(1),
        map((m) => {
          if (m === true) {
            this.ctx.EmployeeId = employeeId;
            this.ctx.Employee = x;
            sessionStorage.setItem('EmployeeId', String(employeeId));
            sessionStorage.setItem('Employee', JSON.stringify(x));

            if (this.ctx.HasHWC === false) {

              // if not using HWC, select branch from employee's default branch setting.
              var eb = this.defaultData.defData.Branches.find(i => i.BranchId == x.BranchId);
              if (eb) {
                // The following line of code was commented out because when user logs in, it can override the branch selected,
                // this.selectBranch(x.BranchId);
              }
            }

            this.autoLogout.start();
            this.events.SessionContextChanged(this.ctx);

            return APIResult.CreateAPIResult(1, '/frontoffice/aptbook');
          } else {
            this.autoLogout.stop();
            return APIResult.CreateAPIResult(0, '/checkin');
          }
        }));
    } else {
      return this.employeeAuth.EmployeeLogout(this.ctx.EmployeeId, this.ctx.BranchId, this.ctx.TerminalId).pipe(
        take(1),
        map((m) => {
          this.ctx.EmployeeId = -1;
          this.ctx.Employee = null;
          this.autoLogout.stop();
          this.autoLogout.reset();

          sessionStorage.removeItem('EmployeeId');
          sessionStorage.removeItem('Employee');

          this.events.UserLogOutComplete();
          this.events.SessionContextChanged(this.ctx);

          return APIResult.CreateAPIResult(1, '/checkin');
        })
      );
    }
  }

  getResourcesForBranch(BranchId: number, ActiveOnly: boolean = true): Resource[] {
    let x = this?.defaultData?.defData?.Resources?.filter(i => i.Branch === BranchId);
    if (ActiveOnly && x) {
      x = x.filter(i => i.Active);
    }
    return x;
  }

  getReasonCodes(reasonCatgegory: enumReasonCategory): any {
    const x = this?.defaultData?.defData?.ReasonCodes?.filter(
      (i) => i.ReasonCategory === enumReasonCategory.All || i.ReasonCategory === reasonCatgegory
    ).sort((a, b) => a.Summary.toLocaleLowerCase().localeCompare(b.Summary.toLocaleLowerCase()));
    return x;
  }

  public DoesTerminalNeedToBeRegistered(): boolean {
    const b = this.GetSelectedBranch();
    const t = this.GetSelectedTerminal();
    if (b && t === undefined && this.ctx.TerminalIP) {
      return true;
    } else {
      return false;
    }
  }

  public DoesTerminalHaveTill(): boolean {
    return (this.GetSelectedTerminal()?.TillConnected && this.GetSelectedTerminal()?.Branch === this.GetSelectedBranch()?.BranchId) || false;
  }

  public get DoesTerminalHaveTPayPoint(): boolean {
    return (this.GetSelectedTerminal()?.PayPointConnected && this.GetSelectedTerminal()?.PayPoint && this.GetSelectedTerminal()?.Branch === this.GetSelectedBranch()?.BranchId) || false;
  }
}
